import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    selectedSkillImage: null,
    croppedSkillImage: null,
    isSkillImageModalOpen: false,
    isSkillImageDeleteOpen: false,
  },
};

const skillImageSlice = createSlice({
  name: "skillImage",
  initialState,
  reducers: {
    updateSkillImageData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
  },
});

export const { updateSkillImageData } = skillImageSlice.actions;

export default skillImageSlice.reducer;
